import { render, staticRenderFns } from "./pi-home-site-ranking.vue?vue&type=template&id=18eb98f8&"
import script from "./pi-home-site-ranking.vue?vue&type=script&lang=ts&"
export * from "./pi-home-site-ranking.vue?vue&type=script&lang=ts&"
import style0 from "./pi-home-site-ranking.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports